import { useEffect, useState } from "react";
import { MonitorFaturamentoService } from "../../../../services";
import { responseErros } from "../../../../utils";
import MonitorFatCard from "./monitor-fat-card.view";
import MonitorFatRankingBarra from "./monitor-fat-ranking-barra.view";

const monitorFaturamentoService = new MonitorFaturamentoService();

function MonitorFatGrupoProduto({ filtrosBody }) {
  const [loading, setLoading] = useState(false);
  const [rows, setRows] = useState([]);

  useEffect(() => {
    buscarGrupoProduto();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filtrosBody]);

  async function buscarGrupoProduto() {
    setLoading(true);
    const result = await monitorFaturamentoService.faturamentoGrupoProduto(
      filtrosBody,
    );
    if (!result.isAxiosError) {
      setRows(result.data || []);
    } else {
      responseErros(result);
    }
    setLoading(false);
  }

  const itens = rows.map((r) => ({
    key: r.grupoProdutoId ?? "sem-grupo",
    label: r.grupoProdutoId ? r.nomeGrupoProduto : "Sem grupo",
    valor: r.valor,
  }));

  return (
    <MonitorFatCard
      titulo="Faturamento por Grupo de Produtos"
      icone="ph-squares-four"
      loading={loading}
    >
      <MonitorFatRankingBarra itens={itens} corBarra="#1976d2" />
    </MonitorFatCard>
  );
}

export default MonitorFatGrupoProduto;
